import { FilePdfOutlined } from "@ant-design/icons";
import { DownloadDocumentButton, PostInvoiceButton } from "../../common/components";
import db from "../../../../db/database";
import { downloadInvoicePdfFromBC } from "../../../../utils/businessCentralUtils";
import { getSerieNCFBySeriesCode } from "../../../../services/serieNCFService";
import { ok, fail } from "../../../../utils/common";
import { COUNTRY_CODES, countryMap } from "../../../../constants/countries"
import { getFinalDocumentNo } from "../../../../services/invoiceSyncService";

//************************************InvoiceForm.js slots************************************
import { ClientSectionSlot as ClientSection } from "./ClientSectionSlot";
import { BillingInfoSectionSlot as BillingInfoSection } from "../../common/components";
import InvoiceHeaderSlot from "./InvoiceHeader";

export { ClientSection, BillingInfoSection, InvoiceHeaderSlot };

//************************************InvoiceList.js methods************************************
const getSerieNcfAndNo = async (invoice) => {
    const country = countryMap[COUNTRY_CODES.ELSALVADOR];
    let No = '';

    try {
        if (!invoice?.No) {
            No = await getFinalDocumentNo(invoice, country);
        }
    }
    catch (error) {
        window.messageApi.destroy(); //Elimino mensaje de error devuelto por getFinalDocumentNo
        return fail(`No se encontró un número de documento final para el número preasignado ${invoice.Pre_Assigned_No}.`);
    }

    const invoiceFinal = await db.invoices.get(invoice.id);

    //este error significa que se contabilizo, pero la api de BC no devuelve las series
    if (!invoiceFinal?.No_Serie_NCF_Facturas && !invoiceFinal?.No_Serie_NCF_Abonos) {
        console.log(`No_Serie_NCF vacío para factura ${No}`)
        return ok(true);
    }

    const NCF = invoiceFinal.Document_Type === 'Credit Memo' ? invoiceFinal.No_Serie_NCF_Abonos : invoiceFinal.No_Serie_NCF_Facturas;

    const serie = await getSerieNCFBySeriesCode(NCF);

    if (!serie) {
        return fail(`Serie ${invoiceFinal.No_Serie_NCF_Facturas} no encontrada`);
    }

    await db.invoices.update(invoice.id, {
        No: No,
        No_Autorizacion_CAI: serie?.No_Autorizacion_CAI,
        Fecha_Autorizacion: serie?.Fecha_Autorizacion,
        Fecha_Caducidad: serie?.Fecha_Caducidad,
        Establecimiento: serie?.Establecimiento,
        Punto_de_Emision: serie?.Punto_de_Emision,
        Tipo_Comprobante: serie?.Tipo_Comprobante,
        Starting_No: serie?.Starting_No,
        Ending_No: serie?.Ending_No,
    });

    return ok(true);
}

const handleSalvadorInvoiceDownload = async (invoice, setLoading) => {
    try {
        setLoading(true);

        if (!invoice?.systemId) {
            const resultSerieNcfAndNo = await getSerieNcfAndNo(invoice);

            if (!resultSerieNcfAndNo.ok) {
                window.messageApi.error(resultSerieNcfAndNo.message);
                return;
            }

            invoice = await db.invoices.get(invoice.id);

            if (!invoice?.systemId) {
                window.messageApi.error("La factura aún no está contabilizada.");
                return;
            }
        }

        await downloadInvoicePdfFromBC({
            documentNo: invoice.No,
            documentType: invoice.Document_Type,
            fileName: invoice.Document_Type === "Credit Memo"
                ? `NotaCredito_${invoice.No}.pdf`
                : `Factura_${invoice.No}.pdf`,
        });
    }
    catch (error) {
        window.messageApi.error("Error al descargar la factura.");
    }
    finally {
        setLoading(false);
    }
};

//************************************InvoiceList.js slots************************************
export const DownloadTicketButton = (props) => { return null; }

export const DownloadInvoiceButton = (props) => {
    return (
        <DownloadDocumentButton
            {...props}
            icon={<FilePdfOutlined />}
            title="Descargar factura"
            onDownload={handleSalvadorInvoiceDownload}
        />
    );
};

export { PostInvoiceButton };